import React from "react";
import { Container, Button, Form, Offcanvas } from "react-bootstrap";
import api from "../api/api";
import { withTranslation } from "react-i18next";
import SensorList from "./SensorList.js";
import LeafletMap from "./map";
import QrScannerPanel from "./QrScannerPanel";
import swal from "sweetalert";
import "./AddSensor.css";

class AddSensor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      toggle: false,
      isLoading: true,
      zoom: "",
      center: [],
      fromAction: false,
      resultScan: "",
      codeError: "",
      zonesData: [],
      farmsData: [],
      description: "",
      field_uid: "",
      zone_uid: "",
      Latitude: "",
      Longitude: "",
      positionError: "",
      farms: [],
      sensorList: [],
      layerType: "",
      sensorName: "",
      draw: {
        polygon: false,
        circle: false,
        rectangle: false,
        polyline: false,
        marker: true,
        circlemarker: false,
      },
      edit: { delete: false, edit: false },
    };
  }

  componentDidMount() {
    this.getDataFields();
    this.getDataZones();
    this.getListSensors();
  }

  getListSensors = async () => {
    try {
      const res = await api.get("/sensor/sensors");
      this.setState({ sensorList: res.data });
    } catch (error) {
      console.error(error);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  getDataZones = async () => {
    try {
      const res = await api.get("/zone/zones");
      const farms = res.data.farms || [];
      const zonesData = farms.flatMap((farm) =>
        (farm.fields || []).flatMap((field) =>
          (field.zones || []).map((zone) => ({ name: zone.name, Uid: zone.uid }))
        )
      );
      this.setState({ zonesData });
    } catch (error) {
      console.error(error);
    }
  };

  getDataFields = async () => {
    try {
      const res = await api.get("/field/fields");
      const farms = res.data.farms || [];
      const farmsData = farms.flatMap((farm) =>
        (farm.fields || []).map((field) => ({ title: field.name, Uid: field.uid }))
      );
      this.setState({ farms, farmsData });
    } catch (error) {
      console.error(error);
    }
  };

  _onCreated = (event) => {
    const { layer, layerType } = event;
    const { lat, lng } = layer.getLatLng();
    this.setState({
      layerType,
      Latitude: lat,
      Longitude: lng,
      positionError: "",
    });
  };

  onLocationSelected = ({ lat, lng }) => {
    this.setState({ Latitude: lat, Longitude: lng, positionError: "" });
  };

  handleUidField = (event) => this.setState({ field_uid: event.target.value });
  handleUidZone = (event) => this.setState({ zone_uid: event.target.value });
  handleDescription = (event) => this.setState({ description: event.target.value });
  handleScan = (event) => this.setState({ resultScan: event.target.value, codeError: "" });
  handleSensorName = (event) => this.setState({ sensorName: event.target.value });

  onNewScanResult = (decodedText) => {
    this.setState({ resultScan: decodedText, codeError: "" });
  };

  validateSensor = () => {
    const { t } = this.props;
    const codeError = this.state.resultScan.trim()
      ? ""
      : t("sensor_code_required", { defaultValue: "Le code du capteur est obligatoire." });
    const positionError =
      this.state.Latitude !== "" && this.state.Longitude !== ""
        ? ""
        : t("sensor_position_required", { defaultValue: "Choisissez la position du capteur sur la carte." });

    this.setState({ codeError, positionError });
    return !codeError && !positionError;
  };

  handleSubmit = (event) => {
    event.preventDefault();
    if (this.validateSensor()) this.addSensor();
  };

  addSensor = async () => {
    const { t } = this.props;
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    const data = {
      name: this.state.sensorName,
      code: this.state.resultScan,
      description: this.state.description,
      field_uid: this.state.field_uid,
      zone_uid: this.state.zone_uid,
      user_uid: user?.id,
      Latitude: this.state.Latitude,
      Longitude: this.state.Longitude,
    };

    try {
      const res = await api.post("/sensor/add-sensor", data);
      if (res.data.errors || res.data.type === "danger") {
        swal({ title: t("Cannot add sensor"), icon: "error", text: t("Error") });
        return;
      }

      if (res.data.type === "success") {
        await this.getListSensors();
        this.resetForm();
        swal({ title: t("sensor_added"), icon: "success", text: t("Sensor added successfully") });
      }
    } catch (error) {
      console.error(error);
      swal({ title: t("Cannot add sensor"), icon: "error", text: t("Error") });
    }
  };

  resetForm = () => {
    this.setState({
      toggle: false,
      sensorName: "",
      resultScan: "",
      description: "",
      field_uid: "",
      zone_uid: "",
      Latitude: "",
      Longitude: "",
      layerType: "",
      codeError: "",
      positionError: "",
    });
  };

  render() {
    const { t } = this.props;
    const { toggle, isLoading, sensorList } = this.state;

    return (
      <Container fluid className="main-content-container sensor-settings-page">
        <header className="sensor-settings-header">
          <div>
            <span className="sensor-settings-eyebrow">SMARTFARM</span>
            <h1>{t("my_sensors")}</h1>
            <p>{t("add_sensor_page_subtitle", { defaultValue: "Gérez vos capteurs, leur affectation et leur position depuis un seul espace." })}</p>
          </div>
          <Button type="button" className="sensor-add-button" onClick={() => this.setState({ toggle: true })}>
            <i className="fas fa-plus" aria-hidden="true" />
            {t("add_sensor")}
          </Button>
        </header>

        {isLoading ? (
          <div className="sensor-list-skeleton" aria-busy="true" aria-live="polite">
            <span className="visually-hidden">{t("loading")}</span>
            <div className="sensor-skeleton-heading" />
            {[1, 2, 3].map((item) => <div className="sensor-skeleton-row" key={item} />)}
          </div>
        ) : (
          <section className="sensor-list-section">
            <div className="sensor-section-heading">
              <span className="sensor-section-icon"><i className="fas fa-broadcast-tower" aria-hidden="true" /></span>
              <div><span>{t("inventory", { defaultValue: "Inventaire" })}</span><h2>{t("my_sensors")}</h2></div>
              <strong>{sensorList.length}</strong>
            </div>
            <SensorList sensorsData={sensorList} Sensors={this.getListSensors} />
          </section>
        )}

        <Offcanvas show={toggle} onHide={() => this.setState({ toggle: false })} placement="end" scroll backdrop className="sensor-create-drawer">
          <Offcanvas.Header closeButton className="sensor-drawer-header">
            <div className="sensor-drawer-title">
              <span className="sensor-section-icon"><i className="fas fa-microchip" aria-hidden="true" /></span>
              <div><span>{t("new_device", { defaultValue: "Nouveau dispositif" })}</span><Offcanvas.Title>{t("configure_sensor", { defaultValue: "Configurer un capteur" })}</Offcanvas.Title></div>
            </div>
          </Offcanvas.Header>

          <Offcanvas.Body className="sensor-drawer-body">
            <Form className="sensor-create-form" onSubmit={this.handleSubmit}>
              <section className="sensor-form-step">
                <div className="sensor-step-heading"><strong>1</strong><div><span>{t("identification", { defaultValue: "Identification" })}</span><p>{t("sensor_step_identification_help", { defaultValue: "Identifiez le capteur par son nom et son code." })}</p></div></div>
                <div className="form-group">
                  <label htmlFor="sensor-name">{t("sensor_Name")}</label>
                  <Form.Control id="sensor-name" placeholder={t("sensor_Name")} value={this.state.sensorName} onChange={this.handleSensorName} />
                </div>
                <div className="form-group sensor-code-field">
                  <label htmlFor="sensor-code">{t("sensor_code")}</label>
                  <Form.Control id="sensor-code" placeholder={t("sensor_code")} value={this.state.resultScan} onChange={this.handleScan} className={this.state.codeError ? "is-invalid" : ""} />
                  {this.state.codeError && <div className="invalid-feedback">{this.state.codeError}</div>}
                </div>
                <QrScannerPanel onScan={this.onNewScanResult} />
              </section>

              <section className="sensor-form-step">
                <div className="sensor-step-heading"><strong>2</strong><div><span>{t("assignment", { defaultValue: "Affectation" })}</span><p>{t("sensor_step_assignment_help", { defaultValue: "Associez le capteur à son champ et à sa zone." })}</p></div></div>
                <div className="sensor-form-grid">
                  <div className="form-group">
                    <label htmlFor="sensor-field">{t("name_field")}</label>
                    <Form.Select id="sensor-field" value={this.state.field_uid} onChange={this.handleUidField}>
                      <option value="">{t("select_field")}</option>
                      {this.state.farmsData.map((item, index) => <option key={item.Uid || index} value={item.Uid}>{item.title}</option>)}
                    </Form.Select>
                  </div>
                  <div className="form-group">
                    <label htmlFor="sensor-zone">{t("name_zone")}</label>
                    <Form.Select id="sensor-zone" value={this.state.zone_uid} onChange={this.handleUidZone}>
                      <option value="">{t("select_zone")}</option>
                      {this.state.zonesData.map((item, index) => <option key={item.Uid || index} value={item.Uid}>{item.name}</option>)}
                    </Form.Select>
                  </div>
                </div>
                <div className="form-group sensor-description-field">
                  <label htmlFor="sensor-description">{t("description", { defaultValue: "Description" })}</label>
                  <Form.Control as="textarea" id="sensor-description" rows={3} placeholder={t("sensor_description_placeholder", { defaultValue: "Informations complémentaires (facultatif)" })} value={this.state.description} onChange={this.handleDescription} />
                </div>
              </section>

              <section className="sensor-form-step sensor-position-step">
                <div className="sensor-step-heading"><strong>3</strong><div><span>{t("position", { defaultValue: "Position" })}</span><p>{t("sensor_step_position_help", { defaultValue: "Utilisez l’icône de localisation ou placez le marqueur sur la carte." })}</p></div></div>
                <div className="sensor-map-column">
                  <div className="sensor-map-heading">
                    <span><i className="fas fa-map-marker-alt" aria-hidden="true" /></span>
                    <div><small>{t("position_required", { defaultValue: "Position obligatoire" })}</small><h3>{t("add_sensor_position")}</h3></div>
                  </div>
                  <LeafletMap
                    type={this.state.layerType}
                    _onCreated={this._onCreated}
                    draw={this.state.draw}
                    edit={this.state.edit}
                    farms={this.state.farms}
                    data={sensorList}
                    zoom={this.state.zoom}
                    center={this.state.center}
                    fromAction={this.state.fromAction}
                    enableAutoLocation={false}
                    showLocationControl
                    onLocationSelected={this.onLocationSelected}
                  />
                </div>
                {this.state.positionError && <div className="sensor-position-error">{this.state.positionError}</div>}
                {this.state.Latitude !== "" && this.state.Longitude !== "" && <p className="sensor-location-ready"><i className="fas fa-check-circle" aria-hidden="true" /> {t("position_selected", { defaultValue: "Position sélectionnée" })}</p>}
              </section>

              <div className="sensor-drawer-footer">
                <Button type="button" className="sensor-modal-cancel" onClick={() => this.setState({ toggle: false })}>{t("cancel")}</Button>
                <Button type="submit" className="sensor-save-button"><i className="fa fa-check" aria-hidden="true" /> {t("add_sensor_submit", { defaultValue: "Ajouter le capteur" })}</Button>
              </div>
            </Form>
          </Offcanvas.Body>
        </Offcanvas>
      </Container>
    );
  }
}

export default withTranslation()(AddSensor);
